import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageSeo } from '../components/Seo';
import { useBlog } from '../context/BlogContext';
import { formatBlogDate, getBlogPostThumbnail } from '../utils/blog';

export default function Blog() {
  const { posts, isLoading, error, refreshPosts } = useBlog();

  useEffect(() => {
    void refreshPosts({ silent: posts.length > 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPosts]);

  return (
    <div className="container blog-page">
      <PageSeo
        title="Blog"
        description="Sağlık, longevity ve cihaz kullanımı hakkında güncel yazılar."
        path="/blog"
        type="website"
      />

      <header className="blog-page-header">
        <h1>Blog</h1>
        <p>Sağlık, longevity ve ürünlerimiz hakkında bilgilendirici yazılar.</p>
      </header>

      {error && (
        <div className="auth-error">
          {error}
          <button type="button" className="btn btn-outline btn-sm" onClick={() => void refreshPosts()}>
            Tekrar Dene
          </button>
        </div>
      )}

      {isLoading ? (
        <p>Yazılar yükleniyor...</p>
      ) : posts.length === 0 ? (
        <div className="empty-state">
          <p>Henüz yayınlanmış blog yazısı yok.</p>
        </div>
      ) : (
        <div className="blog-grid">
          {posts.map((post) => {
            const thumbnail = getBlogPostThumbnail(post);
            const postPath = `/blog/${post.slug}`;

            return (
              <article key={post.id} className="blog-card">
                <Link to={postPath} className="blog-card-thumb-link" aria-label={post.title}>
                  {thumbnail ? (
                    <img src={thumbnail} alt="" className="blog-card-thumb" loading="lazy" />
                  ) : (
                    <div className="blog-card-thumb blog-card-thumb-placeholder" aria-hidden="true">
                      <span>Blog</span>
                    </div>
                  )}
                </Link>

                <div className="blog-card-body">
                  <div className="blog-card-meta">
                    <time dateTime={post.publishedAt ?? post.createdAt}>
                      {formatBlogDate(post.publishedAt ?? post.createdAt)}
                    </time>
                    {post.author && <span>{post.author}</span>}
                  </div>
                  <h2>
                    <Link to={postPath}>{post.title}</Link>
                  </h2>
                  {post.excerpt && <p>{post.excerpt}</p>}
                  <Link to={postPath} className="link-arrow">
                    Devamını Oku →
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
